/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

export default {
    '.textTileWithProduct-container': {
        '.textTile-products-block': {
            '.product-tile-block': {
                background: 'white',
                borderRadius: '8px',
                margin: '0 16px 0 0',
                padding: '0'
            },
            '.product-tile-body': {
                px: '4',
                pt: '4'
            },
            '.addtocartbutton ': {
                width: 'calc(100% - 32px)',
                mx: '4'
            },
            '.preandbackOrderMessage': {
                width: 'calc(100% - 32px)',
                mx: '4'
            }
        },
        '&.power-reviews-section .textTile-main-block .textTile-inner-block': {
            '.heading, .textDescription': {
                paddingBottom: {base: '14px', md: '16px'}
            },
            '.heading': {
                fontSize: {base: '32px', md: '40px'},
                lineHeight: {base: '40px', md: '52px'}
            }
        },
        '.pr-irlsnippet': {
            '.pr-irlsnippet-leftbtn, .pr-irlsnippet-rightbtn': {
                background: 'rgba(0, 0, 0, 0.75)',
                boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.20)',
                position: 'absolute',
                top: '40%',
                zIndex: '9',
                padding: '8px',
                display: ['none', 'none', 'block'],
                '.pr-caret-icon svg polyline': {
                    stroke: 'white'
                }
            },
            '.pr-irlsnippet-leftbtn': {
                left: '0',
                borderRadius: '0 8px 8px 0'
            },
            '.pr-irlsnippet-rightbtn': {
                right: '0',
                borderRadius: '8px 0 0 8px'
            },
            '.pr-irlsnippet-images .pr-irlsnippet-image-container': {
                marginRight: '8px',
                borderRadius: '8px',
                img: {
                    borderRadius: '8px'
                }
            }
        },
        '.product-items-inner-block': {
            msOverflowStyle: 'none' /* IE and Edge */,
            scrollbarWidth: 'none' /* Firefox */,
            padding: '0 20% 0 0',
            marginLeft: {base: '16px', md: '32px', lg: '0'},
            /* Hide scrollbar for Chrome, Safari and Opera */
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        },
        '.wishlistButton': {
            position: 'absolute',
            top: '8px',
            right: '8px'
        },
        '.slick-arrow': {
            background: 'rgba(0, 0, 0, .75)',
            padding: '16px 8px',
            top: '50% !important',
            transform: 'translateY(-50%)',
            '&.slick-prev': {
                borderRadius: '8px 0 0px 8px',
                transform: 'translateY(-50%) rotateY(180deg)',
                left: '0',
                right: 'auto',
                zIndex: '1'
            },
            '&.slick-next': {
                borderRadius: '8px 0 0 8px'
            }
        },
        '.slick-slider .slick-list': {
            marginRight: {
                base: '0',
                xl: '60px'
            },
            overflow: {
                base: 'hidden',
                xl: 'unset'
            }
        }
    }
}
